import { render, staticRenderFns } from "./Terminals.vue?vue&type=template&id=48dc74b0&scoped=true"
import script from "./Terminals.vue?vue&type=script&lang=js"
export * from "./Terminals.vue?vue&type=script&lang=js"
import style0 from "./Terminals.vue?vue&type=style&index=0&id=48dc74b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dc74b0",
  null
  
)

export default component.exports